import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { getStorageItem } from "../../utils/sessionStorage";
import Card from "../Card";
import "./list.scss";

// User Information
const userId = getStorageItem("user_id");
const userEmail = getStorageItem("user_email");

// Access Token
const accessToken = getStorageItem("token");

const Index = () => {
  const [myProducts, setMyProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(50);
  const [modal, setModal] = useState(false);
  const [modalId, setModalId] = useState("");

  // Function to handle page
  const handlePage = (input) => {
    if (page === 1 && input === -1) {
      setPage(1);
    } else if (page === pageCount && input === 1) {
      setPage(pageCount);
    } else {
      setPage(page + input);
    }
    setMyProducts([]);
  };

  // Function to fetchMyProducts
  async function fetchMyProducts(sellerId) {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod + `/marketplace/product/getAllProductsBySellerId/${sellerId}`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const listedProducts = await response.json();
      setMyProducts(listedProducts);
      // setPageCount(count);
    } catch (err) {
      console.log(err);
    }
  }

  // Function to fetch sellerId
  // async function fetchSellerId() {
  //   try {
  //     const response = await fetch(global.config.ROOTURL.prod + `/marketplace/seller/getSellerId/${userEmail}`, {
  //       headers: {
  //         Authorization: "Bearer " + accessToken,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     const sellerId = await response.json();
  //     // Call fetchMyProducts function here and pass sellerId
  //     fetchMyProducts(sellerId);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }

  // Product Edit or Delete Modal
  const handleModal = (id) => {
    setModal(!modal);
    setModalId(id);
  };

  // Delete Product
  const handleDeleteProduct = async () => {
    if (!accessToken && !modalId) return;
    try {
      const response = await fetch(
        global.config.ROOTURL.prod + `/marketplace/product/deleteProductByProductId/${modalId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.ok) {
        toast.success("Product deleted successfully");
        const updatedProducts = myProducts.filter((product) => product._id !== modalId);
        setMyProducts(updatedProducts);
        handleModal();
        setModalId("");
      } else {
        toast.error("Some error occured");
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Out of Stock Product
  const handleOutOfStock = async () => {
    if (!modalId && !accessToken) return
    try {
      const response = await fetch(
        global.config.ROOTURL.prod + `/marketplace/product/outOfStockProductByProductId/${modalId}`,
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.ok) {
        toast.success("Product made out of stock successfully");
        handleModal();
        setModalId("");
      } else {
        toast.error("Some error occured");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchMyProducts(userId);
  }, [page]);
  return (
    <div>
      <Helmet>
        <title>Champhunt | MarketPlace-List</title>
      </Helmet>
      {modal && (
        <div className="edit__modal">
          <div className="modal">
            <img
              src="/marketplace/cancel.svg"
              alt="cancel"
              className="cancel__button"
              onClick={handleModal}
            />
            <p className="modal__text">Are you sure you want to Delete?</p>
            <button className="modal__button" onClick={handleDeleteProduct}>
              Yes
            </button>
            <button className="modal__button" onClick={handleOutOfStock}>
              Change to out of Stock
            </button>
          </div>
        </div>
      )}
      <div className="main__container">
        <h1 className="page__title">My Products</h1>
        <div className="products">
          {myProducts
            ? myProducts.map((product, index) => {
              return (
                <Card
                  product={product}
                  index={index}
                  type="editable"
                  handleModal={handleModal}
                />
              );
            })
            : "No new products"}
        </div>
        {/*{pageCount > 1 ? (*/}
        {/*  <div className="pagination">*/}
        {/*    <img*/}
        {/*      src="/marketplace/back-pagination.svg"*/}
        {/*      alt="backward-pagination"*/}
        {/*      className="backward-pagination"*/}
        {/*      onClick={() => {*/}
        {/*        handlePage(-1);*/}
        {/*      }}*/}
        {/*    />*/}
        {/*    <p className="count">*/}
        {/*      {page} of {pageCount}*/}
        {/*    </p>*/}
        {/*    <img*/}
        {/*      src="/marketplace/forward-pagination.svg"*/}
        {/*      alt="forward-pagination"*/}
        {/*      className="forward-pagination"*/}
        {/*      onClick={() => {*/}
        {/*        handlePage(1);*/}
        {/*      }}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*) : (*/}
        {/*  ""*/}
        {/*)}*/}
      </div>
    </div>
  );
};

export default Index;
